<ng-container *ngIf="datos.tipo=='infoProduct'">
  <div class="" fxLayout="row" fxLayoutAlign="center center">
    <h1 mat-dialog-title>{{'CONSULTATABLA.INF_PROD_SEL' | translate}}</h1>
  </div>
  <!-- <h1 mat-dialog-title>{{'CONFING_RESUL.TITULO_MODAL' | translate}}</h1> -->
  <div fxLayout="column" fxLayoutAlign="space-between start" >

    <div fxLayout="row" fxLayoutAlign="space-between start"  class="tamaDiv">
    <mat-form-field appearance="outline" class="tamaMatFo" >
      <mat-label>{{'CONSULTATABLA.EMPRESA' | translate}}</mat-label>
      <input matInput  disabled  [(ngModel)]="nombreEmpresa" >
    </mat-form-field>
    <mat-form-field appearance="outline" class="tamaMatFo">
      <mat-label>{{'CONSULTATABLA.TIP_PRODU' | translate}}</mat-label>
      <input matInput  disabled  [(ngModel)]="tipoProducto" >
    </mat-form-field>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv">
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.SELECT_PLANTILLA' | translate}}</mat-label>
        <input matInput  disabled  [(ngModel)]="nombrePlantilla" >
      </mat-form-field>
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.SELECT_CSSID' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="fechaCertificar" >
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv">
      <mat-form-field appearance="outline" class="" [ngClass]="{'tamaMatFo':yearRanking!=undefined,'tamaMatFov2':yearRanking==undefined}">
        <mat-label>{{'CONSULTATABLA.SELECT_CSSID2' | translate}}</mat-label>
        <input matInput disabled [(ngModel)]="cssId">
      </mat-form-field>
      <mat-form-field appearance="outline" class="tamaMatFo"  *ngIf="yearRanking!=undefined">
        <mat-label>{{'CONSULTATABLA.SELECT_CSSIDR' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="yearRanking" >
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv" *ngIf="rankingType!=undefined && rankingEnabled!=undefined">
      <mat-form-field appearance="outline" class="tamaMatFo">
        <mat-label>{{'CONSULTATABLA.TIPORANKING' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="rankingType" >
      </mat-form-field>
      <mat-form-field appearance="outline" class="tamaMatFo">
        <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.RANKING' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="rankingEnabled" >
      </mat-form-field>


    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv"         *ngIf="rankingRange!=undefined">
      <mat-form-field appearance="outline" class="tamaDiv">
        <mat-label>{{'PERFILES.EMPRESA.SECCIONES.SEC1.TIPO' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="rankingRange" >
      </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv">
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.IDOPORTUNITY' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="oportunity_id" >
      </mat-form-field>
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.NAMEOPORTUNITY' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="oportunity_name" >
      </mat-form-field>

    </div>
    <div fxLayout="row" fxLayoutAlign="space-between start" class="tamaDiv">
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.PROYECTMANAGER' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="fullName" >
      </mat-form-field>
      <mat-form-field appearance="outline" class="tamaMatFo" >
        <mat-label>{{'CONSULTATABLA.PROYECTMANAGER_MAIL' | translate}}</mat-label>
        <input matInput  disabled [(ngModel)]="email" >
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{'CONSULTATABLA.IDTYPERESULT' | translate}}</mat-label>
      <mat-select [(ngModel)]='typeOfResultsId' [disabled]="typeOfResultsId!=undefined">
        <mat-option *ngFor="let tipoResults of typeOfResults" [value]="tipoResults.TypeOfresultsID" (click)="saveTypeResults()" >
          {{'CONSULTATABLA.CAT_RES.'+tipoResults.TypeOfresultsID | translate}}
        </mat-option>
      </mat-select>
      <mat-error></mat-error>
    </mat-form-field>
  </div>
</ng-container>

<ng-container *ngIf="datos.tipo=='confResult'">
  <div class="" fxLayout="column" fxFlex="100">
    <div fxLayout="row" fxLayoutAlign="space-between start">
      <h1 mat-dialog-title class="m-10">{{'CONFING_RESUL.TITULO_MODAL' | translate}}</h1>
      <button mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon" color="warn">close</mat-icon>
      </button>
    </div>
    <ng-container *ngIf="cargando">
      <div  fxFlex="100" style="margin-top:30px" fxLayout="column" fxLayoutAlign="center center">
        <div fxLayout="column" fxLayoutAlign="space-between center" >
          <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
          <h2>{{'CONFING_RESUL.MODAL_CARGA_BENCH' | translate}}</h2>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!cargando">
      <div fxLayout="row" fxLayoutAlign="space-between stretch"  fxFlex="100">
        <div class="" fxLayout="column" fxLayoutAlign="start stretch"  fxFlex="50">
          <div *ngFor="let matCat of matExpandCategorias;let i= index" class="m-10" >
            <mat-expansion-panel  [ngClass]="{'mt-5':i==0}" [expanded]="false" [expanded]="matCat.active" (click)="actionMatExpand(matCat.catego)"
            cdkDropList
            #drop2="cdkDropList"
            [cdkDropListData]="matCat.datos"
            [cdkDropListConnectedTo]="[doneList]"
            (cdkDropListDropped)="drop($event)" id="{{matCat.catego}}">
              <mat-expansion-panel-header class="accent-100" >
                <mat-panel-title>
                  <b class="mr-20">{{matCat.catego}}</b>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class=""fxLayout="column" fxLayoutAlign="start stretch" cdkDropListGroup>
                <mat-form-field appearance="outline" fxFlex="100" style="margin-top:5px">
                  <mat-label>{{'CONFING_RESUL.TEX_SEARC_BENCH' | translate}}</mat-label>
                  <input matInput (keyup)="BenchMarkapplyFilter($event.target.value,matCat.catego)">
                  <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <mat-list role="list" class="example-list tamano">
                <mat-list-item class="listMove" role="listitem" *ngFor="let benchMar of matCat.datos" cdkDrag [cdkDragData]="benchMar">
                  <div class="listMoveInt">
                    <mat-icon aria-hidden="false" class="mr-20" matTooltip="">menu</mat-icon>
                    {{benchMar.NombreBenchmark}}
                    <span class="fw-Broker">
                      <mat-icon aria-hidden="false" class="mr-20 colorIcon" matTooltip="" *ngIf="benchMar.DefaultID!=0">start</mat-icon>
                    </span>

                  </div>
                </mat-list-item>
              </mat-list>
            </div>

          </mat-expansion-panel>
          </div>

  </div>

  <div  fxLayout="column" fxLayoutAlign="start stretch"  fxFlex="48">
    <div class="divBorderBenchMarkSave m-10" fxLayout="column" fxLayoutAlign="space-between stretch" >
      <span style="color: #e40601;margin-left:20px;font-size:20px;margin-top: 20px;display:flex">{{'CONFING_RESUL.BENCHMARCK_SELEC' | translate}} <mat-icon>low_priority</mat-icon></span>
      <div class="divRadioBtn" fxLayout="row" fxLayoutAlign="start center">
        <p>{{'CONFING_RESUL.LABE_INSTRU_SELECT_BENCH' | translate}}</p>
        <mat-radio-group
        aria-labelledby="example-radio-group-label"
        [(ngModel)]="respSiNoAplicaBenchMark">
        <mat-radio-button style="margin-left:10px" *ngFor="let opcion of opcionResp" [value]="opcion.value" (change)="updateNoAplicBenchMark(opcion.value)">
          {{opcion.text}}
        </mat-radio-button>
</mat-radio-group>

<!-- [cdkDropListConnectedTo]="idsDrapDrop" -->
      </div>
        <div
        cdkDropList
        #doneList="cdkDropList"
        [cdkDropListData]="benchMarkSelection"
        [cdkDropListConnectedTo]="idsDrapDropGral"
        class=".example-list tamanoDone"
        (cdkDropListDropped)="drop($event,'2')"
        >
        <ng-container *ngIf="benchMarkSelection.length==0">
          <div fxLayout="column" fxLayoutAlign="center center" style="padding:35px">
            <div [ngClass]="{'DragDropDesActive':noAplicBenchmark,'DragDropActive':!noAplicBenchmark}" fxLayout="column" fxLayoutAlign="center center">
              <mat-icon [ngClass]="{'iconDrapDropDesActive':noAplicBenchmark,'iconDrapDropActive':!noAplicBenchmark}">display_external_input</mat-icon>
              <span class="DragDropText" [ngClass]="{'DragDropTextNoAplic':noAplicBenchmark,'DragDropText':!noAplicBenchmark}">{{'CONFING_RESUL.INSTRU_DRAP&DROP_1' | translate}} </span>
              <!-- <mat-checkbox style="margin-right:20px;margin-top:20px;" [(ngModel)]="noAplicBenchmark" class="DragDropTextNoAplic"(change)="updateNoAplicBenchMark($event)">{{'CONFING_RESUL.INSTRU_DRAP&DROP_2' | translate}} </mat-checkbox> -->
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="benchMarkSelection.length>0">
          <div class="example-box" *ngFor="let item of benchMarkSelection" cdkDrag fxLayout="row" fxLayoutAlign="start start" [cdkDragData]="item" (cdkDragReleased)="demoPrueba($event)">
            <mat-icon aria-hidden="false" class="mr-20" matTooltip="" >menu</mat-icon> {{item.NombreBenchmark}} <span>-{{item.BenchmarkType}}</span><mat-icon aria-hidden="false" class="mr-20 colorIcon"  *ngIf="item.DefaultID!=0">start</mat-icon> <span *ngIf="item.Peso>1" style="margin-left:5px;cursor: pointer;" class="fw-Broker" matTooltipClass="tooltipRanking" [matTooltip]="item.text" matTooltipPosition="right" >  ({{item.Peso}} {{'CONFING_RESUL.INFO_MAS_BENCH_ESPA' | translate}})</span>
          </div>
        </ng-container>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start center">
        <!-- <circle-progress
        [percent]="porcentaje"
        [radius]="70"
        [title]="contadorLimitPuntos"
        [titleFontSize]="40"
        [subtitle]="labelCircleProgress"
        [subtitleFontSize]="11"
        [subtitleColor]="'#0d0d0d'"
        [subtitleFontWeight]="900"
        [showUnits]="false"
        [outerStrokeWidth]="5"
        [innerStrokeWidth]="3"
        [outerStrokeColor]="'#78C000'"
        [innerStrokeColor]="'#C7E596'"
        [animation]="true"
        [animationDuration]="300"
        ></circle-progress> -->
        <div class="indicator" fxLayout="row" fxLayoutAlign="space-between center">
          <ng-container *ngFor="let indica of [0,1,2,3,4,5,6,7,8,9]; let i=index">
            <span *ngIf="i<=indicador-1" class="indicator-item" style="background-color: #e40601;width: 20%;"></span>
            <span *ngIf="i>indicador-1"class="indicator-item" style="background-color: #F3F3F3;width: 20%;"></span>
          </ng-container>
        </div>
        <h2>{{contadorLimitPuntos}} {{labelCircleProgress}}</h2>
      </div>
  </div>
</div>
<div mat-dialog-actions  fxLayout="column" fxLayoutAlign="end end" class="m-10">
<div mat-dialog-actions  fxLayout="row" fxLayoutAlign="space-evenly end">
  <button mat-button  class="primary rndBt" (click)="addFavoritesBenchMark()" [disabled]="benchmarckSugeridosFav.length==0" ><mat-icon matSuffix>add</mat-icon>{{'CONFING_RESUL.BTN_ADD_BENCH_SUGE' | translate}}</button>
  <button mat-button  class="primary rndBt" (click)="GuardarBenchMar()" [disabled]="benchMarkSelection.length==0"><mat-icon matSuffix>save</mat-icon>{{'CONFING_RESUL.BTN_SAV_BENCH' | translate}} </button>
</div>
</div>
</ng-container>

</div>
</ng-container>

<ng-container *ngIf="datos.tipo=='goFlow'">
  <h1 mat-dialog-title>{{'CONFING_RESUL_GOFLOW.TITULO_MODAL' | translate}}</h1>
  <form [formGroup]="datasets[0]" style="width:100%;height:80%">
    <div class="" fxLayout="column" fxLayoutAlign="space-between stretch"  fxFlex="100">
      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[0].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[0].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[0].obligatorio" [formControlName]="columnas[0].clave" (blur)="validarDato($event,columnas[0].validacion,0,columnas[0].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[1].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[1].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[1].obligatorio" [formControlName]="columnas[1].clave" (blur)="validarDato($event,columnas[1].validacion,1,columnas[1].clave)">
          <mat-error >{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch">
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[2].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[2].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[2].obligatorio" [formControlName]="columnas[2].clave" (blur)="validarDato($event,columnas[2].validacion,2,columnas[2].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[3].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[3].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[3].obligatorio" [formControlName]="columnas[3].clave" (blur)="validarDato($event,columnas[3].validacion,3,columnas[3].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch" >
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[4].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[4].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[4].obligatorio" [formControlName]="columnas[4].clave" (blur)="validarDato($event,columnas[4].validacion,4,columnas[4].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[5].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[5].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[5].obligatorio" [formControlName]="columnas[5].clave" (blur)="validarDato($event,columnas[5].validacion,5,columnas[5].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch" >
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[6].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[6].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[6].obligatorio" [formControlName]="columnas[6].clave" (blur)="validarDato($event,columnas[6].validacion,6,columnas[6].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[7].visible">
          <mat-label class="labelTitle">{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[7].clave | translate}}</mat-label>
          <input matInput type="text" [required]="columnas[7].obligatorio" [formControlName]="columnas[7].clave" (blur)="validarDato($event,columnas[7].validacion,7,columnas[7].clave)">
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
        <!-- <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[7].visible">
          <mat-label>{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[7].clave | translate}}</mat-label>
          <input matInput [matDatepicker]="fecLanzamiento" [matDatepickerFilter]="filtroCalendario" [required]="columnas[7].obligatorio" [formControlName]="columnas[7].clave" (dateChange)="validarDato($event,columnas[7].validacion,7,columnas[7].clave)" (click)="fecLanzamiento.open()">
          <mat-datepicker touchUi #fecLanzamiento></mat-datepicker>
          <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field> -->
      </div>
      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch" >
        <mat-form-field appearance="outline" fxFlex="48" *ngIf="columnas[8].visible">
          <mat-label>{{'AVANCES.FORMULARIO_GO_FLOW.'+columnas[8].clave | translate}}</mat-label>
          <input matInput [matDatepicker]="fecLanzamiento" [matDatepickerFilter]="filtroCalendario" [required]="columnas[8].obligatorio" [formControlName]="columnas[8].clave" (dateChange)="validarDato($event,columnas[8].validacion,7,columnas[8].clave)" (click)="fecLanzamiento.open()">
          <mat-datepicker touchUi #fecLanzamiento></mat-datepicker>
          <mat-icon matSuffix class="secondary-text">calendar_today</mat-icon>
          <mat-error>{{'AVANCES.NEWCOLAB.REQUIRED' | translate}}</mat-error>
        </mat-form-field>
      </div>

      <div class="guardandoTemplate" *ngIf="actualizando" fxLayout="row" fxLayoutAlign="start center">
        <em class="mr-20">{{'ODS.MODALES.GUARDANDO' | translate}}</em>
        <mat-spinner diameter="25"></mat-spinner>
      </div>

      <div *ngIf="actualizarInfoSQL">
        <button mat-button color="primary" (click)="guardaInfoGoFlow()" [disabled]="actualizarInfoSQL" class="done mr-20">
          {{'AVANCES.NEWCOLAB.SAVE' | translate}} <mat-icon>save</mat-icon></button>
        </div>
        <div class="finishBt" *ngIf="!actualizarInfoSQL">
          <button mat-button color="primary" (click)="guardaInfoGoFlow()" class="done mr-20">
            {{'AVANCES.NEWCOLAB.SAVE' | translate}} <mat-icon>save</mat-icon></button>
          </div>
        </div>
      </form>
    </ng-container>
